import reduce from 'lodash/reduce';

import { TvGroup } from '@r1-frontend/api-domru/api-tariffs/v1/tariff/calculate/dto/ResponseDto';

import { TTvSubscription } from '~/src/features/tariffBuilder/reducer/initialState';

const prepareTvSubscription = (current: Record<string, TTvSubscription>, incoming: Record<string, TvGroup>, selectedVases: number[]) => {
    return reduce(incoming, (result, group: TvGroup, alias: string) => {
        result[alias] = {
            alias,
            title: group.header,
            imagePath: group.image,
            items: reduce(group.entities, (itemsResult, item) => {
                const isSelectedByResponse = selectedVases.includes(item.id);

                // @ts-ignore
                itemsResult[item.id] = {
                    id: item.id,
                    contentId: item.contentId,
                    title: item.title,
                    cost: {
                        previous: item.oldCost,
                        fact: item.deltaCost,
                        final: item.cost,
                    },
                    quantity: isSelectedByResponse ? 1 : current?.[alias]?.items?.[item.id]?.quantity || 0,
                };

                return itemsResult;
            }, {}),
        };

        return result;
    }, current);
};

export default prepareTvSubscription;
